/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verificationcodeexpirederror3Inputs */

const en_verificationcodeexpirederror3 = /** @type {(inputs: Verificationcodeexpirederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code has expired. Please request a new one.`)
};

const de_verificationcodeexpirederror3 = /** @type {(inputs: Verificationcodeexpirederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestätigungscode ist abgelaufen. Fordere einen neuen an.`)
};

/**
* | output |
* | --- |
* | "Verification code has expired. Please request a new one." |
*
* @param {Verificationcodeexpirederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const verificationcodeexpirederror3 = /** @type {((inputs?: Verificationcodeexpirederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verificationcodeexpirederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verificationcodeexpirederror3(inputs)
	return de_verificationcodeexpirederror3(inputs)
});
export { verificationcodeexpirederror3 as "verificationCodeExpiredError" }